module.exports = __webpack_public_path__ + "img/PhoneOff.07ff3a9f.svg";